import Vue from "vue";
import Vuex from "vuex";

const Document = {
    namespaced: true,
    state: {
        documents: [],
        documentSelected: {},
        missingDocuments: [],
        typeDocuments: [],
        pieces: []
    },
    actions: {
        sendDocument(context, document) {
            return new Promise((resolve) => {
                let formData = new FormData();

                formData.append("file", document);
                formData.append("requestId", document.requestId);

                formData.append("stdUserId", document.stdUserId);
                formData.append("typeDocumentId", document.typeDocumentId);

                Vue.axios.post(window.urlapi + "document", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(
                    () => {
                        resolve();
                        return true;
                    },
                )
            })
        },

        getDocuments(context, requestId) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "request/" + requestId).then(
                    response => {
                        context.commit("GETDOCUMENTS", response.data.data.documents);
                        resolve();
                    },
                );
            })
        },

        getDocumentsFromCerfa(context, typeCerfa) {
            return new Promise((resolve, reject) => {

                Vue.axios.get(window.urlapi + "typedocument").then(
                    response => {


                        if (typeCerfa.length > 1) {
                            for (let i = response.data.data.length; i--;) {
                                if (
                                    !response.data.data[i].cerfa.includes(typeCerfa[0]) &&
                                    !response.data.data[i].cerfa.includes(typeCerfa[1]) &&
                                    !response.data.data[i].cerfa.includes(typeCerfa.join(','))

                                ) {
                                    response.data.data.splice(i, 1);
                                }
                            }
                        } else {
                            for (let i = response.data.data.length; i--;) {
                                if (
                                    !response.data.data[i].cerfa.includes(typeCerfa)
                                ) {
                                    response.data.data.splice(i, 1);
                                }
                            }
                        }


                        let documents = [];

                        for (let i = 0; i < response.data.data.length; i++) {
                            if (response.data.data[i].isMandatory !== null && response.data.data[i].id !== 17 && response.data.data[i].id !== 21 && response.data.data[i].id !== 20) {
                                documents.push(response.data.data[i]);
                            }
                        }

                        context.commit("GETTYPEDOCUMENTS", documents);
                        resolve();
                    },
                );
            })
        },

        getMissingDocuments(context, request) {
            return new Promise((resolve, reject) => {

                Vue.axios.get(window.urlapi + "typedocument").then(
                    response => {
                        if (typeof request.missingDocuments !== 'undefined')
                            for (let i = response.data.data.length; i--;) {
                                if (!request.missingDocuments.includes(response.data.data[i].id.toString())) {
                                    response.data.data.splice(i, 1);
                                }
                            }

                        let documents = [];

                        for (let i = 0; i < response.data.data.length; i++) {
                            documents.push({
                                file: null,
                                typeDocument: response.data.data[i]
                            })
                        }

                        context.commit("GETMISSINGDOCUMENTS", documents);
                        resolve();
                    },
                );
            })
        },

        deleteDocument(context, id) {
            Vue.axios.delete(window.urlapi + "document/" + id).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                    }
                },
            );
        }
    },
    mutations: {
        GETDOCUMENTS: (state, documents) => {
            state.documents = documents;
        },
        GETMISSINGDOCUMENTS: (state, missingDocuments) => {
            state.missingDocuments = missingDocuments;
        },
        GETTYPEDOCUMENTS: (state, typeDocuments) => {
            state.typeDocuments = typeDocuments;
        }
    },
    getters: {
        documents: state => {
            return state.documents;
        },
        typeDocuments: state => {
            return state.typeDocuments;
        },
        missingDocuments: state => {
            return state.missingDocuments;
        },
        countdocument: state => {
            return state.documents.length;
        }
    },
    modules: {}
};

export default Document;
